import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { CacheProvider } from '@emotion/react';
import createEmotionCache from '../server/createEmotionCache';
import MainRouter from './MainRouter';
import { StaticRouter } from 'react-router-dom/server';
// import { BrowserRouter } from 'react-router-dom';
import { MemoryRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from '../redux/store';

import theme from '../common/theme';

export default function App(props) {
  const cache = createEmotionCache();

  if (props.env == 'server') {

    return (
      <html lang="en">
        <head>
          <meta charSet="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta name="description" content="Gridvault Demo site" />
          <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap" />
          {/* <link rel="stylesheet" href="/styles.css" /> */}
          <title>Gridvault Demo</title>
        </head>
        <body>

          <Provider store={store}>
            <StaticRouter location={props.location}>
              <CacheProvider value={cache}>
                <ThemeProvider theme={theme}>
                  {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
                  <CssBaseline />
                  <MainRouter />
                </ThemeProvider>
              </CacheProvider>
            </StaticRouter>
          </Provider>

        </body>
      </html>
    );
  } else {

    return (
      <html lang="en">
        <head>
          <meta charSet="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta name="description" content="Gridvault Demo site" />
          <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap" />
          {/* <link rel="stylesheet" href="/styles.css" /> */}
          <title>Gridvault Demo</title>
        </head>
        <body>

          <Provider store={store}>
            {/* <BrowserRouter> */}
            <MemoryRouter initialEntries={['/']}
              initialIndex={0} >
              {/* <MemoryRouter> */}
              <CacheProvider value={cache}>
                <ThemeProvider theme={theme}>
                  {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
                  <CssBaseline />
                  <MainRouter />
                </ThemeProvider>
              </CacheProvider>
              {/* </BrowserRouter> */}
            </MemoryRouter>
          </Provider>

        </body>
      </html>
    );
  }

}